module.exports = "<app-inteclia-table\n  [columns]=\"columnsDisplay\"\n  [key]=\"'reclamation'\"\n  [ActiveSelectd]=\"false\"\n  [header]=\"false\"\n  [width]=\"router.url\"\n  [config]=\"Display\">\n</app-inteclia-table>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/view/reclamation-view/reclamation-view.component.html
// module id = ./src/app/view/reclamation-view/reclamation-view.component.html
// module chunks = main